import tz from 'tz-lookup'

/**
 * Get timezone using coordinates (accurate) or fallback to state mapping
 * Fixes 900-1300 edge case cities across 9 multi-timezone states
 */
export function getTimezone(latitude?: number | null, longitude?: number | null, stateCode?: string | null): string {
    // Primary: Use coordinates for accurate timezone lookup
    if (latitude != null && longitude != null) {
        try {
            const timezone = tz(latitude, longitude)
            if (timezone) return timezone
        } catch (error) {
            console.warn(`Timezone lookup failed for coordinates (${latitude}, ${longitude}):`, error)
        }
    }

    // Fallback: Use state-based mapping (inaccurate for edge cases)
    if (stateCode) {
        const normalizedCode = stateCode.trim().toUpperCase()
        const timezone = STATE_TIMEZONE_MAP[normalizedCode]
        if (timezone) return timezone
    }

    // Default fallback
    return 'America/New_York'
}

/**
 * Legacy state-to-timezone mapping
 * Note: Inaccurate for 900-1300 cities in 9 multi-timezone states
 */
export const STATE_TIMEZONE_MAP: Record<string, string> = {
    CT: 'America/New_York',
    DE: 'America/New_York',
    FL: 'America/New_York',
    GA: 'America/New_York',
    ME: 'America/New_York',
    MD: 'America/New_York',
    MA: 'America/New_York',
    MI: 'America/Detroit',
    NH: 'America/New_York',
    NJ: 'America/New_York',
    NY: 'America/New_York',
    NC: 'America/New_York',
    OH: 'America/New_York',
    PA: 'America/New_York',
    RI: 'America/New_York',
    SC: 'America/New_York',
    VT: 'America/New_York',
    VA: 'America/New_York',
    WV: 'America/New_York',
    DC: 'America/New_York',
    AL: 'America/Chicago',
    AR: 'America/Chicago',
    IL: 'America/Chicago',
    IN: 'America/Indiana/Indianapolis',
    IA: 'America/Chicago',
    KS: 'America/Chicago',
    KY: 'America/New_York',
    LA: 'America/Chicago',
    MN: 'America/Chicago',
    MS: 'America/Chicago',
    MO: 'America/Chicago',
    NE: 'America/Chicago',
    ND: 'America/Chicago',
    OK: 'America/Chicago',
    SD: 'America/Chicago',
    TN: 'America/Chicago',
    TX: 'America/Chicago',
    WI: 'America/Chicago',
    AZ: 'America/Phoenix',
    CO: 'America/Denver',
    ID: 'America/Boise',
    MT: 'America/Denver',
    NM: 'America/Denver',
    UT: 'America/Denver',
    WY: 'America/Denver',
    CA: 'America/Los_Angeles',
    NV: 'America/Los_Angeles',
    OR: 'America/Los_Angeles',
    WA: 'America/Los_Angeles',
    AK: 'America/Anchorage',
    HI: 'Pacific/Honolulu',
}
